export default __webpack_public_path__ + "static/media/penink04.d35182a8.png";